const radioButtons = (selector) => {
    document.addEventListener("click", function(event) {
        // Make sure clicked element is our toggle
        const el = /** @type {HTMLDivElement} */ (event.target);
        if (!el.classList.contains(selector)) {
            return;
        }

        // Prevent default link behavior
        event.preventDefault();
        const radioEls = document.querySelectorAll("." + selector);

        if (!el.classList.contains("selected")) {
            radioEls.forEach(radioEl => {
                // Switch active to non-active and checked value
                if (!radioEl.classList.contains("selected")) {
                    const radioInput = /** @type {HTMLInputElement} */ (radioEl.querySelector(
                        ".js-radio-input"
                    ));
                    radioInput.checked = true;
                    radioEl.classList.add("selected");
                } else {
                    const radioInput = /** @type {HTMLInputElement} */ (radioEl.querySelector(
                        ".js-radio-input"
                    ));
                    radioInput.checked = false;
                    radioEl.classList.remove("selected");
                }
            });
        }
    });
}

export default radioButtons